import * as React from "react";

// @TODO probably remove if unused
// Tag by Icon Lauk from the Noun Project
// https://thenounproject.com/term/tag/1948174
export function TagIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 30 40" {...props}>
			<path d="M30.71,19.39L12.57,1.26c-0.18-0.189-0.46-0.33-0.71-0.29L2,1C1.45,1,1,1.45,1,2v9.61c-0.09,0.33,0,0.699,0.26,0.96  l18.13,18.14C19.59,30.9,19.84,31,20.1,31c0.261,0,0.511-0.1,0.71-0.29l9.9-9.9C31.1,20.42,31.1,19.78,30.71,19.39z M7,5  c1.1,0,2,0.9,2,2S8.1,9,7,9S5,8.1,5,7S5.9,5,7,5z" />
		</svg>
	);
}

// @TODO probably remove if unused
// Color by Flatart from the Noun Project (edited)
// https://thenounproject.com/term/color/3170709
export function ColorIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 25 32" {...props}>
			<path d="M12.19,0C7.71,6.55,0,13.36,0,19.2a12.14,12.14,0,1,0,24.27,0C24.27,13.44,16.61,6.48,12.19,0Zm-.05,27.74a8.41,8.41,0,0,1-8.4-8.4.9.9,0,0,1,1.8,0,6.61,6.61,0,0,0,6.6,6.6.9.9,0,1,1,0,1.8Z" />
		</svg>
	);
}

// @TODO probably remove if unused
// pictures by DTDesign from the Noun Project (edited)
// https://thenounproject.com/term/pictures/1529846
export function ImagesIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 32 31" {...props}>
			<rect
				x="3.93"
				y="2.71"
				width="11.51"
				height="27.45"
				transform="translate(-1.35 0.88) rotate(-4.84)"
			/>
			<path
				style={{ fill: "#000" }}
				d="M16.14,29.66l-9.48.8a1.47,1.47,0,0,1-1.59-1.34L3,4.73a1.44,1.44,0,0,1,.33-1.06,1.47,1.47,0,0,1,1-.53L11,2.59A.44.44,0,1,0,11,1.72l-6.69.55a2.34,2.34,0,0,0-1.6.83,2.31,2.31,0,0,0-.53,1.7L4.21,29.19a2.34,2.34,0,0,0,2.32,2.15h.21l9.48-.8a.44.44,0,0,0,.4-.47A.43.43,0,0,0,16.14,29.66Z"
			/>
			<rect
				x="9.98"
				y="1.76"
				width="20.46"
				height="27.53"
				transform="matrix(0.99, 0.13, -0.13, 0.99, 2.2, -2.51)"
			/>
			<path
				style={{ fill: "#000" }}
				d="M30.78,2.27,13.61,0A2.35,2.35,0,0,0,11,2L7.81,26.3a2.34,2.34,0,0,0,2,2.63L27,31.18l.31,0a2.35,2.35,0,0,0,2.32-2L32.8,4.9A2.35,2.35,0,0,0,30.78,2.27ZM28.76,29a1.47,1.47,0,0,1-1.65,1.27L9.94,28.06a1.47,1.47,0,0,1-1.27-1.65l.93-7.06,5.28-4.05,2.61,3.39h0l1.37,1.78a.44.44,0,1,0,.69-.53l-1.1-1.44,7.27-5.58,4.42,5.75ZM31.94,4.79,30.28,17.45,26.13,12h0A.42.42,0,0,0,26,12a.43.43,0,0,0-.52,0L17.9,17.81,15.3,14.42a.44.44,0,0,0-.61-.08L9.75,18.13l2.09-16A1.47,1.47,0,0,1,13.31.87h.19L30.67,3.13A1.47,1.47,0,0,1,31.94,4.79Z"
			/>
		</svg>
	);
}

// pass by Kiran Shastry from the Noun Project (edited)
// https://thenounproject.com/term/pass/2253450
export function DataIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 23.84 30.04" {...props}>
			<path d="M2.14,24.32v4.25A1.48,1.48,0,0,0,3.62,30H20.36a1.47,1.47,0,0,0,1.49-1.46V24.32l-4.31,0a.46.46,0,0,1-.45-.47.47.47,0,0,1,.45-.47h0l4.3.05V1.48A1.47,1.47,0,0,0,20.38,0h-6l-.61.51A2.86,2.86,0,0,1,10.1.5L9.5,0H3.62A1.47,1.47,0,0,0,2.14,1.46V23.4m0,0,4.24-.05h0a.47.47,0,0,1,0,.94l-4.25,0m12.28,0H9.5a.46.46,0,0,1,0-.92h4.92a.46.46,0,0,1,0,.92ZM19,15.15H15.25l-3,3.5a.47.47,0,0,1-.34.17H9.67a.46.46,0,0,1-.39-.23.48.48,0,0,1,0-.46l1.61-3H8.48a7.54,7.54,0,0,1-3-.62l-1.75-.75a.46.46,0,0,1-.28-.42V9a.47.47,0,0,1,.46-.47h.87a.46.46,0,0,1,.38.23l1.27,2.07h11a1.42,1.42,0,0,1,1.33.9.52.52,0,0,0,.36.31l.35.09A1.54,1.54,0,0,1,20.5,14,1.52,1.52,0,0,1,19,15.15Z" />
		</svg>
	);
}

export function ShareIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 50 50" {...props}>
			<path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z" />
			<path d="M24 7h2v21h-2z" />
			<path d="M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z" />
		</svg>
	);
}
